import type { FaireProductEntity } from "../../entity_types/product";

export const p_f3z7cyupt9: FaireProductEntity = {
  token: "p_f3z7cyupt9",
  type: "product",
  name: "Sour Strips Rainbow Bites (180G) Spain",
  brandToken: "b_5fqs9qr72c",
  brandName: "Pops Distro Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/0264d605b7f56a465aa1d9fca6a9eebf2d5485c9e49b2d36bbae6a925689c82d.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    "Discounted Sour Strips Rainbow Bites from Spain! Soft, chewy sour candy in a 180g pack. Expires end of April 2026. 🌈🍬\n\nKey Features:\n\n * 🌈 Assorted fruity flavors with sour sugar coating \n * 🍬 Soft, chewy bite-sized candy pieces \n * 📦 180g pack—great for sharing or resale \n * 🇪🇸 Imported from Spain \n * 💲 Discounted item—while supplies last \n * 📅 Expires end of April 2026 ",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:43.542Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
